export function normalizeIds(ids: number[]): number[] {
    return Array.from(new Set(ids)).sort((a, b) => a - b);
}

export function haveSameIds(left: number[], right: number[]): boolean {
    const normalizedLeft = normalizeIds(left);
    const normalizedRight = normalizeIds(right);
    return normalizedLeft.length === normalizedRight.length
        && normalizedLeft.every((id, index) => id === normalizedRight[index]);
}

export function getRemovedIds(currentIds: number[], intendedIds: number[]): number[] {
    const intendedIdSet = new Set(intendedIds);
    return normalizeIds(currentIds.filter(id => !intendedIdSet.has(id)));
}
